export const EMAIL_REGEX = /^\S+@\S+\.\S+$/i;
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!])[A-Za-z\d@$!%*#?&]{8,16}$/;
